import Store from 'store/store';

Store.on('UPDATE_DYNAMIC_DATA', ({ page, data }) => {
	const store = Store.get();
	const dynamicData = store.dynamicData || {};
	store.set({
		dynamicData: {
			...dynamicData,
			[page]: {
				...dynamicData[page],
				...data
			}
		}
	});
});